import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { CdRefreshService } from './cd-refresh.service';

@Injectable()
export class CdRefreshInterceptor implements HttpInterceptor {
    constructor(private cdRefreshService: CdRefreshService) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next
            .handle(req)
            .pipe(finalize(() => this.cdRefreshService.markForCheck()));
    }
}
